import React, { Fragment, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { useDataProvider, useNotify } from 'react-admin';
import ConfirmDialog from 'components/ConfirmDialog';

const useStyles = makeStyles({
  img: {
    marginTop: '10px',
    width: '500px',
    marginRight: '10px',
    cursor: 'pointer',
  },
});

const deletePhoto = async (
  dataProvider,
  jobPhasePhotoId,
  setOpenConfirmDelete,
  notify,
  getJobPhasePhotos,
  handleClose,
) => {
  try {
    await dataProvider.delete('job-phase-photo', {
      id: jobPhasePhotoId,
    });
    notify('Success on Remove!');
  } catch {
    notify(`Error when try to remove the photo`, 'warning');
  }
  getJobPhasePhotos();
  setOpenConfirmDelete(false);
  handleClose();
};

export const ImageViewer = (props: any) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

  return (
    <Fragment>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Image Viewer</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.imageSelected && (
              <img
                className={classes.img}
                src={props.imageSelected.fileUrl}
              ></img>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} color="primary">
            Close
          </Button>
          {!props.isViewPhotos && (
            <Button
              onClick={() => setOpenConfirmDelete(true)}
              color="primary"
              autoFocus
            >
              Delete Photo
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmDialog
        open={openConfirmDelete}
        title={`Are you sure that you want to delete this photo?`}
        handleClose={() => setOpenConfirmDelete(false)}
        onConfirm={() =>
          deletePhoto(
            dataProvider,
            props.imageSelected.id,
            setOpenConfirmDelete,
            notify,
            props.getJobPhasePhotos,
            props.handleClose,
          )
        }
      />
    </Fragment>
  );
};

export default ImageViewer;